<template>
    <div>
        <div class="modal fade" id="bgEditorModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">Background Editor</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">
                        <form>

                            <div class="row mb-3">
                                <label for="formatOptions" class="col-sm-3 col-form-label">Pattern</label>
                                <div class="col-sm-9">
                                    <select id="formatOptions" class="form-select" v-model="background.pattern">
                                        <option>checks</option>
                                        <option>grid</option>
                                        <option>dots</option>
                                        <option>cross-dots</option>
                                        <option>diagonal-lines</option>
                                        <option>horizontal-lines</option>
                                        <option>vertical-lines</option>
                                        <option>diagonal-stripes</option>
                                        <option>horizontal-stripes</option>
                                        <option>vertical-stripes</option>
                                        <option>triangles</option>
                                        <option>zigzag</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <label for="sizeOptions" class="col-sm-3 col-form-label">Size</label>
                                <div class="col-sm-9">
                                    <select id="sizeOptions" class="form-select" v-model="background.patternSize">
                                        <option value="sm">small</option>
                                        <option value="md">medium</option>
                                        <option value="lg">large</option>
                                        <option value="xl">xl</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <label for="color1Options" class="col-sm-3 col-form-label">Color #1</label>
                                <div class="col-sm-9">
                                    <select id="color1Options" class="form-select" v-model="background.color">
                                        <option>dark</option>
                                        <option>light</option>
                                        <option>primary</option>
                                        <option>secondary</option>
                                        <option>success</option>
                                        <option>danger</option>
                                        <option>info</option>
                                        <option>warning</option>
                                        <option>custom</option>
                                        <option v-if="isHexColor">{{background.color}}</option>
                                    </select>
                                    <div v-if="isCustomColor" class="row">
                                        <color-picker :color-object="background" color-field="color" class="mt-2 ms-3"></color-picker>
                                        <label class="editor-content editor-label mt-2">Custom color</label>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <label for="color2Options" class="col-sm-3 col-form-label">Color #2</label>
                                <div class="col-sm-9">
                                    <select id="color2Options" class="form-select" v-model="background.secondaryColor">
                                        <option>dark</option>
                                        <option>light</option>
                                        <option>primary</option>
                                        <option>secondary</option>
                                        <option>success</option>
                                        <option>danger</option>
                                        <option>info</option>
                                        <option>warning</option>
                                        <option>custom</option>
                                        <option v-if="isHexSecondaryColor">{{background.secondaryColor}}</option>
                                    </select>
                                    <div v-if="isCustomSecondaryColor" class="row">
                                        <color-picker :color-object="background" color-field="secondaryColor" class="mt-2 ms-3"></color-picker>
                                        <label class="editor-content editor-label mt-2">Custom color</label>
                                    </div>
                                </div>
                            </div>

                        </form>

                        <div>Preview:</div>
                        <div :key="background.color" :class="patternClass" class="w-100 rounded-lg preview-container" :style="styleClass">

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler" >Ok</button>
                        <button type="button" class="btn btn-secondary " @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ColorPicker from "../../components/ColorPicker.vue";

    export default {
        name: 'BackgroundEditorModal',
        components: {ColorPicker},
        props: {
            yesEvent: Function,
            background: Object
        },
        computed: {
            isCustomColor() {
                return this.background.color && (this.background.color === 'custom' || this.background.color.indexOf('#') === 0) ? true : false
            },
            isHexColor() {
                return this.background.color && this.background.color.indexOf('#') === 0 ? true : false
            },
            isCustomSecondaryColor() {
                return this.background.secondaryColor && (this.background.secondaryColor === 'custom' || this.background.secondaryColor.indexOf('#') === 0) ? true : false
            },
            isHexSecondaryColor() {
                return this.background.secondaryColor && this.background.secondaryColor.indexOf('#') === 0 ? true : false
            },
            patternClass() {
                let pattern = 'pattern-diagonal-stripes-lg'

                if(this.background.pattern && this.background.patternSize) {
                    pattern = 'pattern-' + this.background.pattern + '-' + this.background.patternSize
                }

                if( this.isCustomColor && this.isCustomSecondaryColor ) {
                    return pattern;
                } else if (this.isCustomColor) {
                    return pattern + ' bg-' + this.background.secondaryColor
                } else if (this.isCustomSecondaryColor) {
                    return pattern + ' text-' + this.background.color
                } else {
                    return pattern + ' text-' + this.background.color + ' bg-' + this.background.secondaryColor
                }
            },
            styleClass() {
                const styles = {}

                if(this.isCustomColor) {
                    styles.color = this.background.color
                }

                if (this.isCustomSecondaryColor) {
                    styles.backgroundColor = this.background.secondaryColor
                }

                return styles
            }
        },
        data () {
            return {
                model: webase.model,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('bgEditorModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()

            if(!this.background.color) {
                this.background.color = 'danger'
            }

            if(!this.background.secondaryColor) {
                this.background.color = 'warning'
            }
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {
                // call the parent's "yesEvent"

                if(this.yesEvent) {
                    this.yesEvent()
                }

                // hide the modal
                this.noHandler()
            }
        }
    }
</script>
